import { jsx } from "react/jsx-runtime";
import { FilePreview, UploadProgress } from "@contember/ui";
function InitializingFilePreview({ formatMessage }) {
  return /* @__PURE__ */ jsx(FilePreview, { overlay: /* @__PURE__ */ jsx(UploadProgress, { progress: formatMessage("upload.fileState.inspectingFile") }) });
}
export {
  InitializingFilePreview
};
//# sourceMappingURL=InitializingFilePreview.js.map
